import { render, staticRenderFns } from "./PostoView.vue?vue&type=template&id=10f4493f&"
import script from "./PostoView.vue?vue&type=script&lang=js&"
export * from "./PostoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports